let usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
export const getUsd = function (number) {
    if (number == 0) return 'Free';
    try {
        const res = usdFormatter.format(number);
        if (res.indexOf('NaN') >= 0) {
            throw new Error(`Error formatting currency - supplied: ${number} formatted: ${res}`);
        }
        return res;
    } catch (err) {
        console.error(err);
        return 'Error';
    }
};
